import { TagColor } from '@factorialco/deprecated-design-system'

export default function tagColor(status?: string) {
  const TAG_COLORS: Record<string, TagColor> = {
    approved: TagColor.viridian,
    in_payroll: TagColor.lime,
    sent_to_pay: TagColor.purple,
    rejected: TagColor.radical,
    pending: TagColor.champagne,
    draft: TagColor.grey,
    reversed: TagColor.grey,
    manual: TagColor.viridian,
    automatic: TagColor.grey,
    paid: TagColor.malibu,
    changes_requested: TagColor.champagne,
  }

  return status ? TAG_COLORS[status] || TagColor.grey : TagColor.grey
}
